import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";

export default function Marketing() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/marketing/analytics").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-6">Loading…</div>;

  const cards = [
    ["Total Leads", d.total_leads], ["Leads This Month", d.leads_this_month],
    ["Quotes Started", d.quotes_started], ["Quotes Completed", d.quotes_completed],
    ["Quotes Sold", d.quotes_sold], ["Conversion Rate", `${d.conversion_rate}%`],
  ];
  const colors = ["#0B1E36", "#C5A059", "#64748B", "#334155", "#94A3B8", "#0B1E36"];

  return (
    <div className="p-4 sm:p-6">
      <h1 className="font-display text-3xl font-bold mb-1">Marketing Analytics</h1>
      <p className="text-slate-500 mb-6">See which sources generate the most leads.</p>

      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
        {cards.map(([label, val]) => (
          <div key={label} className="bg-white border border-slate-200 rounded-sm p-4" data-testid={`mkt-${label.replace(/\s/g,'-').toLowerCase()}`}>
            <p className="font-mono text-2xl font-bold">{val}</p>
            <p className="text-xs uppercase tracking-wider text-slate-500 mt-1">{label}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-sm p-5">
          <h3 className="font-display text-lg font-bold mb-4">Leads by Source</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={d.by_source} layout="vertical" margin={{ left: 20 }}>
              <XAxis type="number" allowDecimals={false} />
              <YAxis type="category" dataKey="source" width={110} tick={{ fontSize: 12 }} />
              <Bar dataKey="count" radius={[0, 2, 2, 0]}>
                {d.by_source.map((_, i) => <Cell key={i} fill={colors[i % colors.length]} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white border border-slate-200 rounded-sm p-5">
          <h3 className="font-display text-lg font-bold mb-4">Source Breakdown</h3>
          <div className="space-y-2">
            {d.by_source.map((s) => (
              <div key={s.source} className="flex items-center justify-between border-b border-slate-100 py-2" data-testid={`src-${s.source.replace(/\s/g,'-').toLowerCase()}`}>
                <span className="font-medium text-sm">{s.source}</span>
                <span className="font-mono font-bold">{s.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
